// The exact category slugs the storefront's Menu page filters on
// (ekhoni-khabo-client/src/components/FullMenu/FullMenu.jsx). Previously
// admin forms took category as free-text, so a typo here silently made an
// item invisible under every filter with no warning - this is the fix,
// used to render a checkbox list instead of a text input.
export const CATEGORIES = [
  "iftar_package",
  "late_night",
  "dinner",
  "lunch",
  "breakfast",
  "snacks",
  "drinks",
  "pre_order",
  "catering",
];

export const formatCategoryLabel = (slug) =>
  slug.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
